import { defineComponent as he, h as Le, ref as Me, onMounted as Te, watch as _e, resolveComponent as De, createElementBlock as $e, openBlock as Ne, createVNode as Re, mergeProps as Ue } from "vue";
import { _ as qe } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const O = /^[a-z0-9]+(-[a-z0-9]+)*$/, m = Object.freeze({
  left: 0,
  top: 0,
  width: 16,
  height: 16,
  rotate: 0,
  vFlip: !1,
  hFlip: !1
});
function D(e) {
  return { ...m, ...e };
}
const $ = (e, t, n, i = "") => {
  const o = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (o.length < 2 || o.length > 3)
      return null;
    i = o.shift().slice(1);
  }
  if (o.length > 3 || !o.length)
    return null;
  if (o.length > 1) {
    const c = o.pop(), l = o.pop(), a = {
      provider: o.length > 0 ? o[0] : i,
      prefix: l,
      name: c
    };
    return t && !C(a) ? null : a;
  }
  const r = o[0], s = r.split("-");
  if (s.length > 1) {
    const c = {
      provider: i,
      prefix: s.shift(),
      name: s.join("-")
    };
    return t && !C(c) ? null : c;
  }
  if (n && i === "") {
    const c = {
      provider: i,
      prefix: "",
      name: r
    };
    return t && !C(c, n) ? null : c;
  }
  return null;
}, C = (e, t) => e ? !!((e.provider === "" || e.provider.match(O)) && (t && e.prefix === "" || e.prefix.match(O)) && e.name.match(O)) : !1;
function ze(e, t) {
  const n = { ...e };
  for (const i in m) {
    const o = i;
    if (t[o] !== void 0) {
      const r = t[o];
      if (n[o] === void 0) {
        n[o] = r;
        continue;
      }
      switch (o) {
        case "rotate":
          n[o] = (n[o] + r) % 4;
          break;
        case "hFlip":
        case "vFlip":
          n[o] = r !== n[o];
          break;
        default:
          n[o] = r;
      }
    }
  }
  return n;
}
function re(e, t, n = !1) {
  function i(r, s) {
    if (e.icons[r] !== void 0)
      return Object.assign({}, e.icons[r]);
    if (s > 5)
      return null;
    const c = e.aliases;
    if (c && c[r] !== void 0) {
      const a = c[r], f = i(a.parent, s + 1);
      return f && ze(f, a);
    }
    const l = e.chars;
    return !s && l && l[r] !== void 0 ? i(l[r], s + 1) : null;
  }
  const o = i(t, 0);
  if (o)
    for (const r in m)
      o[r] === void 0 && e[r] !== void 0 && (o[r] = e[r]);
  return o && n ? D(o) : o;
}
function Be(e) {
  for (const t in m)
    if (e[t] !== void 0)
      return !0;
  return !1;
}
function de(e, t, n) {
  n = n || {};
  const i = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return i;
  e.not_found instanceof Array && e.not_found.forEach((s) => {
    t(s, null), i.push(s);
  });
  const o = e.icons;
  Object.keys(o).forEach((s) => {
    const c = re(e, s, !0);
    c && (t(s, c), i.push(s));
  });
  const r = n.aliases || "all";
  if (r !== "none" && typeof e.aliases == "object") {
    const s = e.aliases;
    Object.keys(s).forEach((c) => {
      if (r === "variations" && Be(s[c]))
        return;
      const l = re(e, c, !0);
      l && (t(c, l), i.push(c));
    });
  }
  return i;
}
const K = {
  provider: "string",
  aliases: "object",
  not_found: "object"
};
for (const e in m)
  K[e] = typeof m[e];
function pe(e) {
  if (typeof e != "object" || e === null)
    return null;
  const t = e;
  if (typeof t.prefix != "string" || !e.icons || typeof e.icons != "object")
    return null;
  for (const o in K)
    if (e[o] !== void 0 && typeof e[o] !== K[o])
      return null;
  const n = t.icons;
  for (const o in n) {
    const r = n[o];
    if (!o.match(O) || typeof r.body != "string")
      return null;
    for (const s in m)
      if (r[s] !== void 0 && typeof r[s] != typeof m[s])
        return null;
  }
  const i = t.aliases;
  if (i)
    for (const o in i) {
      const r = i[o], s = r.parent;
      if (!o.match(O) || typeof s != "string" || !n[s] && !i[s])
        return null;
      for (const c in m)
        if (r[c] !== void 0 && typeof r[c] != typeof m[c])
          return null;
    }
  return t;
}
const Ve = 1;
let M = /* @__PURE__ */ Object.create(null);
try {
  const e = window || self;
  e && e._iconifyStorage.version === Ve && (M = e._iconifyStorage.storage);
} catch {
}
function Qe(e, t) {
  return {
    provider: e,
    prefix: t,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ Object.create(null)
  };
}
function j(e, t) {
  M[e] === void 0 && (M[e] = /* @__PURE__ */ Object.create(null));
  const n = M[e];
  return n[t] === void 0 && (n[t] = Qe(e, t)), n[t];
}
function W(e, t) {
  if (!pe(t))
    return [];
  const n = Date.now();
  return de(t, (i, o) => {
    o ? e.icons[i] = o : e.missing[i] = n;
  });
}
function Ke(e, t, n) {
  try {
    if (typeof n.body == "string")
      return e.icons[t] = Object.freeze(D(n)), !0;
  } catch {
  }
  return !1;
}
function He(e, t) {
  const n = e.icons[t];
  return n === void 0 ? null : n;
}
let A = !1;
function ge(e) {
  return typeof e == "boolean" && (A = e), A;
}
function Ye(e) {
  const t = typeof e == "string" ? $(e, !0, A) : e;
  return t ? He(j(t.provider, t.prefix), t.name) : null;
}
function Ge(e, t) {
  const n = $(e, !0, A);
  if (!n)
    return !1;
  const i = j(n.provider, n.prefix);
  return Ke(i, n.name, t);
}
function Je(e, t) {
  if (typeof e != "object")
    return !1;
  if (typeof t != "string" && (t = typeof e.provider == "string" ? e.provider : ""), A && t === "" && (typeof e.prefix != "string" || e.prefix === "")) {
    let i = !1;
    return pe(e) && (e.prefix = "", de(e, (o, r) => {
      r && Ge(o, r) && (i = !0);
    })), i;
  }
  if (typeof e.prefix != "string" || !C({
    provider: t,
    prefix: e.prefix,
    name: "a"
  }))
    return !1;
  const n = j(t, e.prefix);
  return !!W(n, e);
}
const ie = Object.freeze({
  inline: !1,
  width: null,
  height: null,
  hAlign: "center",
  vAlign: "middle",
  slice: !1,
  hFlip: !1,
  vFlip: !1,
  rotate: 0
});
function We(e, t) {
  const n = {};
  for (const i in e) {
    const o = i;
    if (n[o] = e[o], t[o] === void 0)
      continue;
    const r = t[o];
    switch (o) {
      case "inline":
      case "slice":
        typeof r == "boolean" && (n[o] = r);
        break;
      case "hFlip":
      case "vFlip":
        r === !0 && (n[o] = !n[o]);
        break;
      case "hAlign":
      case "vAlign":
        typeof r == "string" && r !== "" && (n[o] = r);
        break;
      case "width":
      case "height":
        (typeof r == "string" && r !== "" || typeof r == "number" && r || r === null) && (n[o] = r);
        break;
      case "rotate":
        typeof r == "number" && (n[o] += r);
        break;
    }
  }
  return n;
}
const Xe = /(-?[0-9.]*[0-9]+[0-9.]*)/g, Ze = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function U(e, t, n) {
  if (t === 1)
    return e;
  if (n = n === void 0 ? 100 : n, typeof e == "number")
    return Math.ceil(e * t * n) / n;
  if (typeof e != "string")
    return e;
  const i = e.split(Xe);
  if (i === null || !i.length)
    return e;
  const o = [];
  let r = i.shift(), s = Ze.test(r);
  for (; ; ) {
    if (s) {
      const c = parseFloat(r);
      isNaN(c) ? o.push(r) : o.push(Math.ceil(c * t * n) / n);
    } else
      o.push(r);
    if (r = i.shift(), r === void 0)
      return o.join("");
    s = !s;
  }
}
function et(e) {
  let t = "";
  switch (e.hAlign) {
    case "left":
      t += "xMin";
      break;
    case "right":
      t += "xMax";
      break;
    default:
      t += "xMid";
  }
  switch (e.vAlign) {
    case "top":
      t += "YMin";
      break;
    case "bottom":
      t += "YMax";
      break;
    default:
      t += "YMid";
  }
  return t += e.slice ? " slice" : " meet", t;
}
function tt(e, t) {
  const n = {
    left: e.left,
    top: e.top,
    width: e.width,
    height: e.height
  };
  let i = e.body;
  [e, t].forEach((c) => {
    const l = [], a = c.hFlip, f = c.vFlip;
    let u = c.rotate;
    a ? f ? u += 2 : (l.push("translate(" + (n.width + n.left).toString() + " " + (0 - n.top).toString() + ")"), l.push("scale(-1 1)"), n.top = n.left = 0) : f && (l.push("translate(" + (0 - n.left).toString() + " " + (n.height + n.top).toString() + ")"), l.push("scale(1 -1)"), n.top = n.left = 0);
    let h;
    switch (u < 0 && (u -= Math.floor(u / 4) * 4), u = u % 4, u) {
      case 1:
        h = n.height / 2 + n.top, l.unshift("rotate(90 " + h.toString() + " " + h.toString() + ")");
        break;
      case 2:
        l.unshift("rotate(180 " + (n.width / 2 + n.left).toString() + " " + (n.height / 2 + n.top).toString() + ")");
        break;
      case 3:
        h = n.width / 2 + n.left, l.unshift("rotate(-90 " + h.toString() + " " + h.toString() + ")");
        break;
    }
    u % 2 === 1 && ((n.left !== 0 || n.top !== 0) && (h = n.left, n.left = n.top, n.top = h), n.width !== n.height && (h = n.width, n.width = n.height, n.height = h)), l.length && (i = '<g transform="' + l.join(" ") + '">' + i + "</g>");
  });
  let o, r;
  t.width === null && t.height === null ? (r = "1em", o = U(r, n.width / n.height)) : t.width !== null && t.height !== null ? (o = t.width, r = t.height) : t.height !== null ? (r = t.height, o = U(r, n.width / n.height)) : (o = t.width, r = U(o, n.height / n.width)), o === "auto" && (o = n.width), r === "auto" && (r = n.height), o = typeof o == "string" ? o : o.toString() + "", r = typeof r == "string" ? r : r.toString() + "";
  const s = {
    attributes: {
      width: o,
      height: r,
      preserveAspectRatio: et(t),
      viewBox: n.left.toString() + " " + n.top.toString() + " " + n.width.toString() + " " + n.height.toString()
    },
    body: i
  };
  return t.inline && (s.inline = !0), s;
}
const nt = /\sid="(\S+)"/g, ot = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let rt = 0;
function it(e, t = ot) {
  const n = [];
  let i;
  for (; i = nt.exec(e); )
    n.push(i[1]);
  return n.length && n.forEach((o) => {
    const r = typeof t == "function" ? t(o) : t + (rt++).toString(), s = o.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    e = e.replace(new RegExp('([#;"])(' + s + ')([")]|\\.[a-z])', "g"), "$1" + r + "$3");
  }), e;
}
const H = /* @__PURE__ */ Object.create(null);
function st(e, t) {
  H[e] = t;
}
function Y(e) {
  return H[e] || H[""];
}
function X(e) {
  let t;
  if (typeof e.resources == "string")
    t = [e.resources];
  else if (t = e.resources, !(t instanceof Array) || !t.length)
    return null;
  return {
    resources: t,
    path: e.path === void 0 ? "/" : e.path,
    maxURL: e.maxURL ? e.maxURL : 500,
    rotate: e.rotate ? e.rotate : 750,
    timeout: e.timeout ? e.timeout : 5e3,
    random: e.random === !0,
    index: e.index ? e.index : 0,
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const Z = /* @__PURE__ */ Object.create(null), k = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], T = [];
for (; k.length > 0; )
  k.length === 1 || Math.random() > 0.5 ? T.push(k.shift()) : T.push(k.pop());
Z[""] = X({
  resources: ["https://api.iconify.design"].concat(T)
});
function ct(e, t) {
  const n = X(t);
  return n === null ? !1 : (Z[e] = n, !0);
}
function ee(e) {
  return Z[e];
}
const ye = (e, t) => {
  let n = e, i = n.indexOf("?") !== -1;
  function o(r) {
    switch (typeof r) {
      case "boolean":
        return r ? "true" : "false";
      case "number":
        return encodeURIComponent(r);
      case "string":
        return encodeURIComponent(r);
      default:
        throw new Error("Invalid parameter");
    }
  }
  return Object.keys(t).forEach((r) => {
    let s;
    try {
      s = o(t[r]);
    } catch {
      return;
    }
    n += (i ? "&" : "?") + encodeURIComponent(r) + "=" + s, i = !0;
  }), n;
}, me = {}, _ = {}, lt = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
  return null;
};
let se = lt();
function at(e, t) {
  const n = ee(e);
  if (!n)
    return 0;
  let i;
  if (!n.maxURL)
    i = 0;
  else {
    let r = 0;
    n.resources.forEach((c) => {
      r = Math.max(r, c.length);
    });
    const s = ye(t + ".json", {
      icons: ""
    });
    i = n.maxURL - r - n.path.length - s.length;
  }
  const o = e + ":" + t;
  return _[e] = n.path, me[o] = i, i;
}
function ft(e) {
  return e === 404;
}
const ut = (e, t, n) => {
  const i = [];
  let o = me[t];
  o === void 0 && (o = at(e, t));
  const r = "icons";
  let s = {
    type: r,
    provider: e,
    prefix: t,
    icons: []
  }, c = 0;
  return n.forEach((l, a) => {
    c += l.length + 1, c >= o && a > 0 && (i.push(s), s = {
      type: r,
      provider: e,
      prefix: t,
      icons: []
    }, c = l.length), s.icons.push(l);
  }), i.push(s), i;
};
function ht(e) {
  if (typeof e == "string") {
    if (_[e] === void 0) {
      const t = ee(e);
      if (!t)
        return "/";
      _[e] = t.path;
    }
    return _[e];
  }
  return "/";
}
const dt = (e, t, n) => {
  if (!se) {
    n("abort", 424);
    return;
  }
  let i = ht(t.provider);
  switch (t.type) {
    case "icons": {
      const r = t.prefix, c = t.icons.join(",");
      i += ye(r + ".json", {
        icons: c
      });
      break;
    }
    case "custom": {
      const r = t.uri;
      i += r.slice(0, 1) === "/" ? r.slice(1) : r;
      break;
    }
    default:
      n("abort", 400);
      return;
  }
  let o = 503;
  se(e + i).then((r) => {
    const s = r.status;
    if (s !== 200) {
      setTimeout(() => {
        n(ft(s) ? "abort" : "next", s);
      });
      return;
    }
    return o = 501, r.json();
  }).then((r) => {
    if (typeof r != "object" || r === null) {
      setTimeout(() => {
        n("next", o);
      });
      return;
    }
    setTimeout(() => {
      n("success", r);
    });
  }).catch(() => {
    n("next", o);
  });
}, pt = {
  prepare: ut,
  send: dt
};
function gt(e) {
  const t = {
    loaded: [],
    missing: [],
    pending: []
  }, n = /* @__PURE__ */ Object.create(null);
  e.sort((o, r) => o.provider !== r.provider ? o.provider.localeCompare(r.provider) : o.prefix !== r.prefix ? o.prefix.localeCompare(r.prefix) : o.name.localeCompare(r.name));
  let i = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((o) => {
    if (i.name === o.name && i.prefix === o.prefix && i.provider === o.provider)
      return;
    i = o;
    const r = o.provider, s = o.prefix, c = o.name;
    n[r] === void 0 && (n[r] = /* @__PURE__ */ Object.create(null));
    const l = n[r];
    l[s] === void 0 && (l[s] = j(r, s));
    const a = l[s];
    let f;
    a.icons[c] !== void 0 ? f = t.loaded : s === "" || a.missing[c] !== void 0 ? f = t.missing : f = t.pending;
    const u = {
      provider: r,
      prefix: s,
      name: c
    };
    f.push(u);
  }), t;
}
const v = /* @__PURE__ */ Object.create(null), q = /* @__PURE__ */ Object.create(null);
function be(e, t) {
  e.forEach((n) => {
    const i = n.provider;
    if (v[i] === void 0)
      return;
    const o = v[i], r = n.prefix, s = o[r];
    s && (o[r] = s.filter((c) => c.id !== t));
  });
}
function yt(e, t) {
  q[e] === void 0 && (q[e] = /* @__PURE__ */ Object.create(null));
  const n = q[e];
  n[t] || (n[t] = !0, setTimeout(() => {
    if (n[t] = !1, v[e] === void 0 || v[e][t] === void 0)
      return;
    const i = v[e][t].slice(0);
    if (!i.length)
      return;
    const o = j(e, t);
    let r = !1;
    i.forEach((s) => {
      const c = s.icons, l = c.pending.length;
      c.pending = c.pending.filter((a) => {
        if (a.prefix !== t)
          return !0;
        const f = a.name;
        if (o.icons[f] !== void 0)
          c.loaded.push({
            provider: e,
            prefix: t,
            name: f
          });
        else if (o.missing[f] !== void 0)
          c.missing.push({
            provider: e,
            prefix: t,
            name: f
          });
        else
          return r = !0, !0;
        return !1;
      }), c.pending.length !== l && (r || be([
        {
          provider: e,
          prefix: t
        }
      ], s.id), s.callback(c.loaded.slice(0), c.missing.slice(0), c.pending.slice(0), s.abort));
    });
  }));
}
let mt = 0;
function bt(e, t, n) {
  const i = mt++, o = be.bind(null, n, i);
  if (!t.pending.length)
    return o;
  const r = {
    id: i,
    icons: t,
    callback: e,
    abort: o
  };
  return n.forEach((s) => {
    const c = s.provider, l = s.prefix;
    v[c] === void 0 && (v[c] = /* @__PURE__ */ Object.create(null));
    const a = v[c];
    a[l] === void 0 && (a[l] = []), a[l].push(r);
  }), o;
}
function vt(e, t = !0, n = !1) {
  const i = [];
  return e.forEach((o) => {
    const r = typeof o == "string" ? $(o, !1, n) : o;
    (!t || C(r, n)) && i.push({
      provider: r.provider,
      prefix: r.prefix,
      name: r.name
    });
  }), i;
}
var ce = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function wt(e, t, n, i) {
  const o = e.resources.length, r = e.random ? Math.floor(Math.random() * o) : e.index;
  let s;
  if (e.random) {
    let d = e.resources.slice(0);
    for (s = []; d.length > 1; ) {
      const g = Math.floor(Math.random() * d.length);
      s.push(d[g]), d = d.slice(0, g).concat(d.slice(g + 1));
    }
    s = s.concat(d);
  } else
    s = e.resources.slice(r).concat(e.resources.slice(0, r));
  const c = Date.now();
  let l = "pending", a = 0, f, u = null, h = [], p = [];
  typeof i == "function" && p.push(i);
  function y() {
    u && (clearTimeout(u), u = null);
  }
  function x() {
    l === "pending" && (l = "aborted"), y(), h.forEach((d) => {
      d.status === "pending" && (d.status = "aborted");
    }), h = [];
  }
  function N(d, g) {
    g && (p = []), typeof d == "function" && p.push(d);
  }
  function Ee() {
    return {
      startTime: c,
      payload: t,
      status: l,
      queriesSent: a,
      queriesPending: h.length,
      subscribe: N,
      abort: x
    };
  }
  function E() {
    l = "failed", p.forEach((d) => {
      d(void 0, f);
    });
  }
  function oe() {
    h.forEach((d) => {
      d.status === "pending" && (d.status = "aborted");
    }), h = [];
  }
  function Pe(d, g, S) {
    const P = g !== "success";
    switch (h = h.filter((w) => w !== d), l) {
      case "pending":
        break;
      case "failed":
        if (P || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (g === "abort") {
      f = S, E();
      return;
    }
    if (P) {
      f = S, h.length || (s.length ? R() : E());
      return;
    }
    if (y(), oe(), !e.random) {
      const w = e.resources.indexOf(d.resource);
      w !== -1 && w !== e.index && (e.index = w);
    }
    l = "completed", p.forEach((w) => {
      w(S);
    });
  }
  function R() {
    if (l !== "pending")
      return;
    y();
    const d = s.shift();
    if (d === void 0) {
      if (h.length) {
        u = setTimeout(() => {
          y(), l === "pending" && (oe(), E());
        }, e.timeout);
        return;
      }
      E();
      return;
    }
    const g = {
      status: "pending",
      resource: d,
      callback: (S, P) => {
        Pe(g, S, P);
      }
    };
    h.push(g), a++, u = setTimeout(R, e.rotate), n(d, t, g.callback);
  }
  return setTimeout(R), Ee;
}
function It(e) {
  if (typeof e != "object" || typeof e.resources != "object" || !(e.resources instanceof Array) || !e.resources.length)
    throw new Error("Invalid Reduncancy configuration");
  const t = /* @__PURE__ */ Object.create(null);
  let n;
  for (n in ce)
    e[n] !== void 0 ? t[n] = e[n] : t[n] = ce[n];
  return t;
}
function ve(e) {
  const t = It(e);
  let n = [];
  function i() {
    n = n.filter((c) => c().status === "pending");
  }
  function o(c, l, a) {
    const f = wt(t, c, l, (u, h) => {
      i(), a && a(u, h);
    });
    return n.push(f), f;
  }
  function r(c) {
    const l = n.find((a) => c(a));
    return l !== void 0 ? l : null;
  }
  return {
    query: o,
    find: r,
    setIndex: (c) => {
      t.index = c;
    },
    getIndex: () => t.index,
    cleanup: i
  };
}
function le() {
}
const z = /* @__PURE__ */ Object.create(null);
function jt(e) {
  if (z[e] === void 0) {
    const t = ee(e);
    if (!t)
      return;
    const n = ve(t), i = {
      config: t,
      redundancy: n
    };
    z[e] = i;
  }
  return z[e];
}
function xt(e, t, n) {
  let i, o;
  if (typeof e == "string") {
    const r = Y(e);
    if (!r)
      return n(void 0, 424), le;
    o = r.send;
    const s = jt(e);
    s && (i = s.redundancy);
  } else {
    const r = X(e);
    if (r) {
      i = ve(r);
      const s = e.resources ? e.resources[0] : "", c = Y(s);
      c && (o = c.send);
    }
  }
  return !i || !o ? (n(void 0, 424), le) : i.query(t, o, n)().abort;
}
const G = {};
function ae() {
}
const I = /* @__PURE__ */ Object.create(null), B = /* @__PURE__ */ Object.create(null), V = /* @__PURE__ */ Object.create(null), Q = /* @__PURE__ */ Object.create(null);
function St(e, t) {
  V[e] === void 0 && (V[e] = /* @__PURE__ */ Object.create(null));
  const n = V[e];
  n[t] || (n[t] = !0, setTimeout(() => {
    n[t] = !1, yt(e, t);
  }));
}
const fe = /* @__PURE__ */ Object.create(null);
function kt(e, t, n) {
  function i() {
    const c = (e === "" ? "" : "@" + e + ":") + t, l = Math.floor(Date.now() / 6e4);
    fe[c] < l && (fe[c] = l, console.error('Unable to retrieve icons for "' + c + '" because API is not configured properly.'));
  }
  B[e] === void 0 && (B[e] = /* @__PURE__ */ Object.create(null));
  const o = B[e];
  Q[e] === void 0 && (Q[e] = /* @__PURE__ */ Object.create(null));
  const r = Q[e];
  I[e] === void 0 && (I[e] = /* @__PURE__ */ Object.create(null));
  const s = I[e];
  o[t] === void 0 ? o[t] = n : o[t] = o[t].concat(n).sort(), r[t] || (r[t] = !0, setTimeout(() => {
    r[t] = !1;
    const c = o[t];
    delete o[t];
    const l = Y(e);
    if (!l) {
      i();
      return;
    }
    l.prepare(e, t, c).forEach((f) => {
      xt(e, f, (u, h) => {
        const p = j(e, t);
        if (typeof u != "object") {
          if (h !== 404)
            return;
          const y = Date.now();
          f.icons.forEach((x) => {
            p.missing[x] = y;
          });
        } else
          try {
            const y = W(p, u);
            if (!y.length)
              return;
            const x = s[t];
            y.forEach((N) => {
              delete x[N];
            }), G.store && G.store(e, u);
          } catch (y) {
            console.error(y);
          }
        St(e, t);
      });
    });
  }));
}
const Ot = (e, t) => {
  const n = vt(e, !0, ge()), i = gt(n);
  if (!i.pending.length) {
    let a = !0;
    return t && setTimeout(() => {
      a && t(i.loaded, i.missing, i.pending, ae);
    }), () => {
      a = !1;
    };
  }
  const o = /* @__PURE__ */ Object.create(null), r = [];
  let s, c;
  i.pending.forEach((a) => {
    const f = a.provider, u = a.prefix;
    if (u === c && f === s)
      return;
    s = f, c = u, r.push({
      provider: f,
      prefix: u
    }), I[f] === void 0 && (I[f] = /* @__PURE__ */ Object.create(null));
    const h = I[f];
    h[u] === void 0 && (h[u] = /* @__PURE__ */ Object.create(null)), o[f] === void 0 && (o[f] = /* @__PURE__ */ Object.create(null));
    const p = o[f];
    p[u] === void 0 && (p[u] = []);
  });
  const l = Date.now();
  return i.pending.forEach((a) => {
    const f = a.provider, u = a.prefix, h = a.name, p = I[f][u];
    p[h] === void 0 && (p[h] = l, o[f][u].push(h));
  }), r.forEach((a) => {
    const f = a.provider, u = a.prefix;
    o[f][u].length && kt(f, u, o[f][u]);
  }), t ? bt(t, i, r) : ae;
}, we = "iconify2", F = "iconify", Ie = F + "-count", je = F + "-version", xe = 36e5, Ct = 168, te = {
  local: !0,
  session: !0
};
let J = !1;
const Se = {
  local: 0,
  session: 0
}, ke = {
  local: [],
  session: []
};
let L = typeof window > "u" ? {} : window;
function Oe(e) {
  const t = e + "Storage";
  try {
    if (L && L[t] && typeof L[t].length == "number")
      return L[t];
  } catch {
  }
  return te[e] = !1, null;
}
function ne(e, t, n) {
  try {
    return e.setItem(Ie, n.toString()), Se[t] = n, !0;
  } catch {
    return !1;
  }
}
function Ce(e) {
  const t = e.getItem(Ie);
  if (t) {
    const n = parseInt(t);
    return n || 0;
  }
  return 0;
}
function At(e, t) {
  try {
    e.setItem(je, we);
  } catch {
  }
  ne(e, t, 0);
}
function Ft(e) {
  try {
    const t = Ce(e);
    for (let n = 0; n < t; n++)
      e.removeItem(F + n.toString());
  } catch {
  }
}
const Ae = () => {
  if (J)
    return;
  J = !0;
  const e = Math.floor(Date.now() / xe) - Ct;
  function t(n) {
    const i = Oe(n);
    if (!i)
      return;
    const o = (r) => {
      const s = F + r.toString(), c = i.getItem(s);
      if (typeof c != "string")
        return !1;
      let l = !0;
      try {
        const a = JSON.parse(c);
        if (typeof a != "object" || typeof a.cached != "number" || a.cached < e || typeof a.provider != "string" || typeof a.data != "object" || typeof a.data.prefix != "string")
          l = !1;
        else {
          const f = a.provider, u = a.data.prefix, h = j(f, u);
          l = W(h, a.data).length > 0;
        }
      } catch {
        l = !1;
      }
      return l || i.removeItem(s), l;
    };
    try {
      const r = i.getItem(je);
      if (r !== we) {
        r && Ft(i), At(i, n);
        return;
      }
      let s = Ce(i);
      for (let c = s - 1; c >= 0; c--)
        o(c) || (c === s - 1 ? s-- : ke[n].push(c));
      ne(i, n, s);
    } catch {
    }
  }
  for (const n in te)
    t(n);
}, Et = (e, t) => {
  J || Ae();
  function n(i) {
    if (!te[i])
      return !1;
    const o = Oe(i);
    if (!o)
      return !1;
    let r = ke[i].shift();
    if (r === void 0 && (r = Se[i], !ne(o, i, r + 1)))
      return !1;
    try {
      const s = {
        cached: Math.floor(Date.now() / xe),
        provider: e,
        data: t
      };
      o.setItem(F + r.toString(), JSON.stringify(s));
    } catch {
      return !1;
    }
    return !0;
  }
  Object.keys(t.icons).length && (t.not_found && (t = Object.assign({}, t), delete t.not_found), n("local") || n("session"));
}, Fe = /[\s,]+/;
function Pt(e, t) {
  t.split(Fe).forEach((n) => {
    switch (n.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
function Lt(e, t) {
  t.split(Fe).forEach((n) => {
    const i = n.trim();
    switch (i) {
      case "left":
      case "center":
      case "right":
        e.hAlign = i;
        break;
      case "top":
      case "middle":
      case "bottom":
        e.vAlign = i;
        break;
      case "slice":
      case "crop":
        e.slice = !0;
        break;
      case "meet":
        e.slice = !1;
    }
  });
}
function Mt(e, t = 0) {
  const n = e.replace(/^-?[0-9.]*/, "");
  function i(o) {
    for (; o < 0; )
      o += 4;
    return o % 4;
  }
  if (n === "") {
    const o = parseInt(e);
    return isNaN(o) ? 0 : i(o);
  } else if (n !== e) {
    let o = 0;
    switch (n) {
      case "%":
        o = 25;
        break;
      case "deg":
        o = 90;
    }
    if (o) {
      let r = parseFloat(e.slice(0, e.length - n.length));
      return isNaN(r) ? 0 : (r = r / o, r % 1 === 0 ? i(r) : 0);
    }
  }
  return t;
}
const Tt = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": !0,
  role: "img"
};
let b = {};
["horizontal", "vertical"].forEach((e) => {
  ["Align", "Flip"].forEach((t) => {
    const i = {
      attr: e.slice(0, 1) + t,
      boolean: t === "Flip"
    };
    b[e + "-" + t.toLowerCase()] = i, b[e.slice(0, 1) + "-" + t.toLowerCase()] = i, b[e + t] = i;
  });
});
const ue = (e, t) => {
  const n = We(ie, t), i = { ...Tt };
  let o = typeof t.style == "object" && !(t.style instanceof Array) ? { ...t.style } : {};
  for (let l in t) {
    const a = t[l];
    if (a !== void 0)
      switch (l) {
        // Properties to ignore
        case "icon":
        case "style":
        case "onLoad":
          break;
        // Boolean attributes
        case "inline":
        case "hFlip":
        case "vFlip":
          n[l] = a === !0 || a === "true" || a === 1;
          break;
        // Flip as string: 'horizontal,vertical'
        case "flip":
          typeof a == "string" && Pt(n, a);
          break;
        // Alignment as string
        case "align":
          typeof a == "string" && Lt(n, a);
          break;
        // Color: override style
        case "color":
          o.color = a;
          break;
        // Rotation as string
        case "rotate":
          typeof a == "string" ? n[l] = Mt(a) : typeof a == "number" && (n[l] = a);
          break;
        // Remove aria-hidden
        case "ariaHidden":
        case "aria-hidden":
          a !== !0 && a !== "true" && delete i["aria-hidden"];
          break;
        default:
          b[l] !== void 0 ? b[l].boolean && (a === !0 || a === "true" || a === 1) ? n[b[l].attr] = !0 : !b[l].boolean && typeof a == "string" && a !== "" && (n[b[l].attr] = a) : ie[l] === void 0 && (i[l] = a);
      }
  }
  const r = tt(e, n);
  for (let l in r.attributes)
    i[l] = r.attributes[l];
  r.inline && o.verticalAlign === void 0 && o["vertical-align"] === void 0 && (o.verticalAlign = "-0.125em");
  let s = 0, c = t.id;
  return typeof c == "string" && (c = c.replace(/-/g, "_")), i.innerHTML = it(r.body, c ? () => c + "ID" + s++ : "iconifyVue"), Object.keys(o).length > 0 && (i.style = o), Le("svg", i);
};
ge(!0);
st("", pt);
if (typeof document < "u" && typeof window < "u") {
  G.store = Et, Ae();
  const e = window;
  if (e.IconifyPreload !== void 0) {
    const t = e.IconifyPreload, n = "Invalid IconifyPreload syntax.";
    typeof t == "object" && t !== null && (t instanceof Array ? t : [t]).forEach((i) => {
      try {
        // Check if item is an object and not null/array
        (typeof i != "object" || i === null || i instanceof Array || // Check for 'icons' and 'prefix'
        typeof i.icons != "object" || typeof i.prefix != "string" || // Add icon set
        !Je(i)) && console.error(n);
      } catch {
        console.error(n);
      }
    });
  }
  if (e.IconifyProviders !== void 0) {
    const t = e.IconifyProviders;
    if (typeof t == "object" && t !== null)
      for (let n in t) {
        const i = "IconifyProviders[" + n + "] is invalid.";
        try {
          const o = t[n];
          if (typeof o != "object" || !o || o.resources === void 0)
            continue;
          ct(n, o) || console.error(i);
        } catch {
          console.error(i);
        }
      }
  }
}
const _t = D({
  body: ""
}), Dt = he({
  // Do not inherit other attributes: it is handled by render()
  inheritAttrs: !1,
  // Set initial data
  data() {
    return {
      // Mounted status
      iconMounted: !1,
      // Callback counter to trigger re-render
      counter: 0
    };
  },
  mounted() {
    this._name = "", this._loadingIcon = null, this.iconMounted = !0;
  },
  unmounted() {
    this.abortLoading();
  },
  methods: {
    abortLoading() {
      this._loadingIcon && (this._loadingIcon.abort(), this._loadingIcon = null);
    },
    // Get data for icon to render or null
    getIcon(e, t) {
      if (typeof e == "object" && e !== null && typeof e.body == "string")
        return this._name = "", this.abortLoading(), {
          data: D(e)
        };
      let n;
      if (typeof e != "string" || (n = $(e, !1, !0)) === null)
        return this.abortLoading(), null;
      const i = Ye(n);
      if (i === null)
        return (!this._loadingIcon || this._loadingIcon.name !== e) && (this.abortLoading(), this._name = "", this._loadingIcon = {
          name: e,
          abort: Ot([n], () => {
            this.counter++;
          })
        }), null;
      this.abortLoading(), this._name !== e && (this._name = e, t && t(e));
      const o = ["iconify"];
      return n.prefix !== "" && o.push("iconify--" + n.prefix), n.provider !== "" && o.push("iconify--" + n.provider), { data: i, classes: o };
    }
  },
  // Render icon
  render() {
    this.counter;
    const e = this.$attrs, t = this.iconMounted ? this.getIcon(e.icon, e.onLoad) : null;
    if (!t)
      return ue(_t, e);
    let n = e;
    return t.classes && (n = {
      ...e,
      class: (typeof e.class == "string" ? e.class + " " : "") + t.classes.join(" ")
    }), ue(t.data, n);
  }
}), $t = he({
  name: "vs-icon",
  components: {
    Icon: Dt
  },
  emits: ["onLoad"],
  props: {
    name: { type: String, required: !0 },
    color: { type: String, default: "black" },
    size: { type: Number, default: 24 },
    horizontalFlip: { type: Boolean, default: !1 },
    verticalFlip: { type: Boolean, default: !1 },
    rotate: { type: Number, default: 0 },
    inline: { type: Boolean, default: !0 }
  },
  setup(e, { emit: t }) {
    const n = Me(null);
    return Te(() => {
      n.value.classList.add("class", `text-${e.color}`);
    }), _e(
      () => e.color,
      (i, o) => {
        n.value.classList.remove(`text-${o}`), n.value.classList.add(`text-${i}`);
      }
    ), { icon: n, emit: t };
  }
}), Nt = { ref: "icon" };
function Rt(e, t, n, i, o, r) {
  const s = De("Icon");
  return Ne(), $e("div", Nt, [
    Re(s, Ue(e.$attrs, {
      inline: e.inline,
      icon: e.name,
      width: e.size,
      height: e.size,
      horizontalFlip: e.horizontalFlip,
      verticalFlip: e.verticalFlip,
      rotate: e.rotate,
      onOnLoad: t[0] || (t[0] = (c) => e.emit("onLoad"))
    }), null, 16, ["inline", "icon", "width", "height", "horizontalFlip", "verticalFlip", "rotate"])
  ], 512);
}
const zt = /* @__PURE__ */ qe($t, [["render", Rt]]);
export {
  zt as v
};
//# sourceMappingURL=vsIcon-Cyr63bPF.mjs.map
